/* ------------------------------------------------------------------
   Panier Game Over Brewing : logique MuratDesigns
   V1 (sept. 2026) : boutons + / -, jauge du minimum de commande.
   V2 « Inventaire » (26/09/2026) :
   - enrichit la reponse panier d'Udesly AVANT le rendu du gabarit
     (window._editUdeslyCartResponse) : style, degre, fond, prix barre
     lus dans le catalogue #gob-catalogue pose en Liquid dans le header
   - jauge a deux paliers : minimum 35 EUR, puis livraison offerte a 24 canettes
   - compteurs animes (total, lignes), jauge qui se remplit, entree animee
   - « Complete ta commande » : suggestions ajoutees en un clic
------------------------------------------------------------------ */
(function () {
  'use strict';

  var root = document.querySelector('[data-node-type="commerce-cart-wrapper"]');
  if (!root) return;

  var MIN = parseInt(root.getAttribute('data-gob-min') || '3500', 10);
  var SHIP = root.getAttribute('data-gob-ship') || '';
  var OFFERT = parseInt(root.getAttribute('data-gob-offert') || '24', 10) || 24;   // canettes : livraison offerte (réglage « Infos brasserie », repli 24)
  var SEGMENTS = 24;
  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function money(c) { return '€' + ((c || 0) / 100).toFixed(2).replace('.', ','); }
  function num(v) { var n = typeof v === 'number' ? v : parseFloat(v); return isNaN(n) ? 0 : n; }

  /* ---------- catalogue ---------- */
  var CAT = {}, LISTE = [];
  try {
    LISTE = JSON.parse(document.getElementById('gob-catalogue').textContent) || [];
    LISTE.forEach(function (p) { CAT[p.h] = p; });
  } catch (e) { LISTE = []; }

  /* ---------- etat ---------- */
  var etat = { total: 0, canettes: 0, lignes: 0, eco: 0, handles: [], ok: false };
  var avant = { total: null, lignes: {}, lit: 0 };
  var nouveau = null;           // id de variante ajoutee depuis une suggestion

  /* ---------- 0. calendrier + autres articles : frais du second colis (30/10/2026, Romain) ----------
     Le calendrier de l'Avent part seul, port offert (remise automatique de 5 EUR sur le calendrier).
     Si le panier contient AUSSI d'autres articles a expedier, ils partent dans un second colis :
     on ajoute le produit « Frais de port · second colis » (5 EUR, sans expedition), on le retire sinon.
     Les tarifs de livraison Shopify ne peuvent pas faire la difference (un lot y compte comme ses canettes). */
  var CAL = 57680162423110, FRAIS = 57746410504518, fraisEnCours = null;
  var base = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  function fraisEtat(items) {
    var cal = 0, autres = 0, frais = 0;
    (items || []).forEach(function (it) {
      var v = num(it.variant_id), q = num(it.quantity);
      if (v === CAL) cal += q; else if (v === FRAIS) frais += q; else if (it.requires_shipping !== false) autres += q;
    });
    // a partir de OFFERT articles (remise « Frais de port offert 24 cans »), le second colis voyage gratuitement aussi
    return { voulu: cal > 0 && autres > 0 && autres < OFFERT ? 1 : 0, frais: frais };
  }
  function fraisCorriger(e) {
    if (e.frais === e.voulu) return Promise.resolve(false);
    if (fraisEnCours) return fraisEnCours;
    var u = {}; u[FRAIS] = e.voulu;
    fraisEnCours = fetch(base + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: u })
    }).then(function (r) { return r.json(); }).then(function () {
      fraisEnCours = null;
      if (window.Udesly && Udesly.dispatch) Udesly.dispatch('cart-should-be-updated');
      return true;
    }).catch(function () { fraisEnCours = null; return false; });
    return fraisEnCours;
  }

  /* ---------- 1. enrichir la reponse avant le rendu ---------- */
  var precedent = window._editUdeslyCartResponse;
  window._editUdeslyCartResponse = function (r) {
    if (typeof precedent === 'function') r = precedent(r) || r;
    var total = 0, canettes = 0, eco = 0, handles = [];
    (r.items || []).forEach(function (it) {
      var c = CAT[it.handle] || null;
      var unit = num(it.final_price), qte = num(it.quantity), ligne = num(it.final_line_price);
      var biere = (/biere|bière/i.test(it.product_type || '') || !!c) && !(c && c.g);   // le verre (g) ne compte pas comme une canette
      var cmp = c && c.n === 1 && c.c > unit ? c.c : 0;
      it.gobStyle = c ? c.s : '';
      it.gobDegre = c ? c.d : '';
      it.gobFond = c ? c.f : '';
      it.gobImage = c && c.i ? c.i : '';
      it.gobUnite = biere ? 'canette' : 'unité';
      it.gobObjet = !biere;   // verre, merch : photo cadrée dans la vignette, pas traitée comme une canette
      it.gobUnit = money(unit);
      it.gobLigne = money(ligne);
      it.gobPromo = cmp ? Math.round((1 - unit / cmp) * 100) : 0;
      it.gobBarreUnit = cmp ? money(cmp) : '';
      it.gobBarreLigne = cmp ? money(cmp * qte) : '';
      total += ligne;
      if (biere) canettes += qte;
      if (cmp) eco += (cmp - unit) * qte;
      handles.push(it.handle);
    });
    eco += num(r.total_discount);
    var lignes = (r.items || []).filter(function (it) { return num(it.variant_id) !== FRAIS; }).length;
    etat = { total: total, canettes: canettes, lignes: lignes, eco: eco, handles: handles, ok: true };
    var fe = fraisEtat(r.items);
    if (fe.frais !== fe.voulu) setTimeout(function () { fraisCorriger(fe); }, 0);
    return r;
  };

  /* ---------- 2. compteurs ---------- */
  function compter(el, de, a, duree) {
    if (!el) return;
    if (reduit || de === a || de == null) { el.textContent = money(a); return; }
    var t0 = null; duree = duree || 650;
    el.classList.add('is-compte');
    function pas(t) {
      if (!t0) t0 = t;
      var k = Math.min((t - t0) / duree, 1), e = 1 - Math.pow(1 - k, 3);
      el.textContent = money(Math.round(de + (a - de) * e));
      if (k < 1) requestAnimationFrame(pas); else el.classList.remove('is-compte');
    }
    requestAnimationFrame(pas);
  }

  /* ---------- 3. jauge ---------- */
  var jauge = root.querySelector('[data-gob-jauge]');
  var seg = jauge && jauge.querySelector('.gob-jauge__seg');
  var msg = jauge && jauge.querySelector('.gob-jauge__msg');
  var repG = root.querySelector('[data-gob-rep-g]');
  var repD = root.querySelector('[data-gob-rep-d]');
  if (seg && !seg.children.length) {
    for (var i = 0; i < SEGMENTS; i++) seg.appendChild(document.createElement('i'));
  }
  function jaugeRendu(depuisZero) {
    if (!jauge) return;
    var garderErreur = msg && msg.querySelector('.is-erreur') && erreur._t && !depuisZero;
    var t = etat.total, n = etat.canettes, ratio;
    var ancien = msg.innerHTML;
    if (t < MIN) {
      ratio = t / MIN;
      msg.innerHTML = 'Plus que <strong>' + money(MIN - t) + '</strong> pour atteindre le minimum de commande de ' + (MIN / 100) + ' €' + '.';
      repG.textContent = money(t) + ' dans ton panier';
      repD.textContent = 'Minimum ' + (MIN / 100) + ' €';
    } else if (n < OFFERT) {
      ratio = n / OFFERT;
      var reste = OFFERT - n;
      msg.innerHTML = '<span class="is-ok">✓ Minimum atteint.</span> Encore <strong>' + reste + ' canette' + (reste > 1 ? 's' : '') + '</strong> et la livraison est offerte.';
      repG.textContent = n + ' canette' + (n > 1 ? 's' : '');
      repD.textContent = OFFERT + ' canettes · livraison offerte';
    } else {
      ratio = 1;
      msg.innerHTML = '<span class="is-ok">✓ Livraison offerte débloquée.</span> Tu peux commander.';
      repG.textContent = n + ' canettes';
      repD.textContent = 'Livraison offerte';
    }
    if (garderErreur) msg.innerHTML = ancien;
    jauge.classList.toggle('is-ok', t >= MIN);
    var lit = Math.max(t > 0 ? 1 : 0, Math.round(Math.min(ratio, 1) * SEGMENTS));
    var de = depuisZero ? 0 : avant.lit;
    Array.prototype.forEach.call(seg.children, function (s, idx) {
      // chaque case s'allume a son tour, dans le sens du remplissage
      var ordre = lit >= de ? idx - de : de - 1 - idx;
      s.style.transitionDelay = reduit ? '0s' : Math.max(ordre, 0) * 28 + 'ms';
      s.classList.toggle('is-on', idx < lit);
    });
    avant.lit = lit;
  }

  /* ---------- 4. suggestions « Complete ta commande » ---------- */
  var plus = root.querySelector('[data-gob-plus]');
  var grille = root.querySelector('[data-gob-plus-grille]');
  var plusCle = '';
  function suggestions() {
    if (!plus) return;
    // le verre 50 cl d'abord (toujours propose tant qu'il n'est pas dans le panier), puis les bieres les plus recentes
    var objets = LISTE.filter(function (p) { return p.g && p.a && p.n === 1 && etat.handles.indexOf(p.h) < 0; }).slice(0, 1);
    var choix = objets.concat(LISTE.filter(function (p) { return !p.g && p.a && p.n === 1 && etat.handles.indexOf(p.h) < 0; })
      .sort(function (a, b) { return b.ts - a.ts; }).slice(0, 3 - objets.length));
    var cle = choix.map(function (p) { return p.h; }).join('|');
    plus.hidden = !choix.length;
    if (cle === plusCle) return;
    plusCle = cle;
    grille.innerHTML = choix.map(function (p) {
      var promo = p.c > p.p;
      return '<div class="gob-mini' + (p.g ? ' gob-mini--objet' : '') + '">' +
        '<a class="gob-mini__vign" href="' + p.u + '" aria-label="' + p.t.replace(/"/g, '&quot;') + '">' +
          '<span class="gob-ci__fond">' + (p.f ? '<img src="' + p.f + '" alt="" loading="lazy">' : '') + '</span>' +
          (p.i ? '<img class="gob-mini__can" src="' + p.i + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="gob-mini__bas"><a class="gob-mini__nom" href="' + p.u + '">' + p.t + '</a>' +
          '<p class="gob-mini__info">' + (p.s ? p.s + ' · ' : '') + '<em>' + money(p.p) + '</em>' + (promo ? ' <s>' + money(p.c) + '</s>' : '') + '</p>' +
          '<button type="button" class="gob-mini__ajout" data-gob-ajout="' + p.v + '">+ Ajouter</button></div></div>';
    }).join('');
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-gob-ajout]');
    if (!b) return;
    e.preventDefault();
    if (b.classList.contains('is-charge')) return;
    b.classList.add('is-charge'); b.textContent = 'Ajout…';
    nouveau = b.getAttribute('data-gob-ajout');
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(nouveau, 10), quantity: 1 }] })
    }).then(function () {
      if (window.Udesly && Udesly.dispatch) Udesly.dispatch('cart-should-be-updated');
    }).catch(function () { b.classList.remove('is-charge'); b.textContent = '+ Ajouter'; });
  });

  /* ---------- 5. boutons + / - ---------- */
  root.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.gob-qty__btn') : null;
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.parentNode;
    var input = wrap.querySelector('[data-node-type="cart-quantity"]');
    if (!input) return;
    var current = parseInt(input.value, 10);
    if (isNaN(current)) current = 1;
    var next = current + (btn.getAttribute('data-gob-step') === 'up' ? 1 : -1);
    if (next < 1) next = 1;
    if (next === current) return;
    input.value = next;
    syncButtons(wrap, next);
    // clics rapides : une seule mise a jour, 350 ms apres le dernier clic
    clearTimeout(input._gobT);
    input._gobT = setTimeout(function () { input.dispatchEvent(new Event('change', { bubbles: true })); }, 350);
  });
  function syncButtons(wrap, value) {
    var minus = wrap.querySelector('[data-gob-step="down"]');
    if (minus) minus.disabled = value <= 1;
  }

  /* ---------- 6. commander : bloque sous le minimum ---------- */
  root.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.gob-cart__commander, .gob-cart__paypal');
    if (!b || etat.total >= MIN) return;
    e.preventDefault();
    if (!jauge) return;
    jauge.classList.remove('is-secoue'); void jauge.offsetWidth; jauge.classList.add('is-secoue');
  });

  /* ---------- 6 bis. commander : frais du second colis verifies juste avant la caisse ---------- */
  root.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.gob-cart__commander, .gob-cart__paypal');
    if (!b || etat.total < MIN) return;            // sous le minimum : le bloc 6 s'en occupe
    e.preventDefault(); e.stopImmediatePropagation();
    var cible = b.getAttribute('href') || '/checkout';
    fetch(base + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) { return fraisCorriger(fraisEtat(c.items)); })
      .catch(function () {})
      .then(function () { window.location.href = cible; });
  }, true);

  /* ---------- 7. rendu apres chaque mise a jour ---------- */
  var totalAff = root.querySelector('[data-gob-total-aff]');
  var compteTxt = root.querySelector('[data-gob-compte-txt]');
  var eco = root.querySelector('[data-gob-eco]');
  var ecoVal = root.querySelector('[data-gob-eco-val]');
  var shipValue = root.querySelector('[data-gob-ship-value]');
  var commander = root.querySelector('.gob-cart__commander');
  var ouvert = false;

  function rendu(entree) {
    if (!etat.ok) return;
    root.classList.toggle('gob-cart--vide', etat.lignes === 0);
    if (compteTxt) {
      compteTxt.textContent = etat.lignes
        ? etat.lignes + ' article' + (etat.lignes > 1 ? 's' : '') + ' · ' + etat.canettes + ' canette' + (etat.canettes > 1 ? 's' : '')
        : '';
    }
    // lignes : compteur sur celles qui changent, flash sur la nouvelle
    var vus = {};
    root.querySelectorAll('.gob-ci[data-key]').forEach(function (el, idx) {
      var k = el.getAttribute('data-key'), tot = el.querySelector('.gob-ci__total');
      var v = parseInt(tot.getAttribute('data-gob-compte'), 10) || 0;
      el.style.setProperty('--i', idx);
      if (!entree && avant.lignes[k] != null && avant.lignes[k] !== v) compter(tot, avant.lignes[k], v, 500);
      else tot.textContent = money(v);
      if (!entree && avant.lignes[k] == null && Object.keys(avant.lignes).length) el.classList.add('is-nouveau');
      if (nouveau && k.indexOf(nouveau + ':') === 0) el.classList.add('is-nouveau');
      el.classList.toggle('gob-ci--frais', k.indexOf(FRAIS + ':') === 0);   // frais du second colis : ni quantite ni suppression
      var q = el.querySelector('[data-node-type="cart-quantity"]');
      if (q) syncButtons(q.parentNode, parseInt(q.value, 10) || 1);
      vus[k] = v;
    });
    avant.lignes = vus; nouveau = null;
    compter(totalAff, entree ? 0 : avant.total, etat.total, entree ? 900 : 650);
    avant.total = etat.total;
    if (eco) { eco.hidden = etat.eco <= 0; ecoVal.textContent = money(etat.eco); }
    if (shipValue) {
      var offert = etat.canettes >= OFFERT && etat.total >= MIN;
      shipValue.classList.toggle('is-offert', offert);
      shipValue.parentNode.classList.toggle('is-offert', offert);
      shipValue.textContent = offert ? 'Offerte'
        : (etat.total >= MIN && SHIP ? SHIP.replace(/&#8364;/g, '€').replace(/&#183;/g, '·') : 'Calculée à l’étape suivante');
    }
    if (commander) commander.classList.toggle('is-bloque', etat.total < MIN);
    jaugeRendu(entree);
    suggestions();
    if (entree) {
      var c = root.querySelector('.gob-cart');
      c.classList.remove('is-entree'); void c.offsetWidth; c.classList.add('is-entree');
      setTimeout(function () { c.classList.remove('is-entree'); }, 1400);
    }
  }

  // ouverture du tiroir : Udesly bascule le display du conteneur
  var conteneur = root.querySelector('[data-node-type="commerce-cart-container-wrapper"]');
  if (conteneur && 'MutationObserver' in window) {
    new MutationObserver(function () {
      var visible = conteneur.style.display !== 'none';
      if (visible && !ouvert) { ouvert = true; setTimeout(function () { rendu(true); }, 30); }
      if (!visible) ouvert = false;
    }).observe(conteneur, { attributes: true, attributeFilter: ['style'] });
  }

  /* ---------- 8. bus Udesly (charge apres nous : on empile) ---------- */
  // quantite refusee (stock insuffisant, 422) : Udesly laisse le panier grise
  // et la mauvaise quantite dans le champ. On debloque, on explique, on resynchronise.
  function erreur(e) {
    root.classList.remove('updating');
    var d = e && e.error ? (e.error.description || e.error.message || '') : '';
    if (jauge && msg) {
      msg.innerHTML = '<span class="is-erreur">' + (d ? String(d).replace(/</g, '&lt;') : 'Cette quantité n’est pas disponible.') + '</span>';
      jauge.classList.remove('is-secoue'); void jauge.offsetWidth; jauge.classList.add('is-secoue');
      clearTimeout(erreur._t);
      erreur._t = setTimeout(function () { jaugeRendu(false); }, 4500);
    }
    if (window.Udesly && Udesly.dispatch) Udesly.dispatch('cart-should-be-updated');
  }
  function brancher() {
    window.Udesly.on('cart-updated', function () {
      root.classList.remove('updating');
      setTimeout(function () { rendu(false); }, 0);      // apres le rendu du gabarit
    });
    window.Udesly.on('error', erreur);
  }
  window.Udesly = window.Udesly || [];
  if (Array.isArray(window.Udesly)) window.Udesly.push(brancher); else brancher();
})();
